import { KyrosToken } from "../../rest/kairos/types";
import { MINT_TO_TOKEN, YIELD_TOKEN_IMAGES } from "../../constants/dripTokens";
import { PARTNER_ICON_BY_MINT } from "../../constants/partners";
import { formatAddress } from "../../utils/format";

export interface RewardTokenMeta {
  symbol: string;
  /** Icon candidates, best first. Bundled partner assets win over remote URLs. */
  iconSources: (string | undefined)[];
}

// Resolves a reward-token mint to a display symbol and ordered icon sources,
// reusing the same precedence as the Drip page: bundled partner asset ->
// Kyros token API metadata -> known-token static asset -> shortened address.
export const resolveRewardTokenMeta = (
  mint: string,
  kyrosByMint: Record<string, KyrosToken>
): RewardTokenMeta => {
  const bundled = PARTNER_ICON_BY_MINT[mint];

  const kyros = kyrosByMint[mint];
  if (kyros) {
    return { symbol: kyros.symbol, iconSources: [bundled, kyros.icon] };
  }

  const known = MINT_TO_TOKEN[mint];
  if (known) {
    return {
      symbol: known,
      iconSources: [bundled, YIELD_TOKEN_IMAGES[known as keyof typeof YIELD_TOKEN_IMAGES]],
    };
  }

  return { symbol: formatAddress(mint, 4, 4), iconSources: [bundled] };
};
